import { Flex, Text } from "@capioweb/ui-components"
import React from "react"

interface BmiHeaderProps {
	description: string
	header: string
}

export const BmiHeader: React.FC<BmiHeaderProps> = ({
	description,
	header
}) => {
	return (
		<Flex flexDirection={"column"} px={{ _: 3, l: 19.5 }}>
			<Text variant={"headline-1"}>{header}</Text>
			<Flex w={{ l: "60%" }}>
				<Text variant={"preamble"}>{description}</Text>
			</Flex>
		</Flex>
	)
}
